import { CollapseProps } from 'antd';
import { FormikProps } from 'formik';

import { MFilter } from '@Components/Base';
import { useAppSelector } from '@Hooks/index';
import { DateRange, Input, MultiSelect } from '@Components/Filters';
import {
  getCompanyLabels,
  getRequestTypeOptionLabels,
} from '@Store/selectors/dictionarySelector';

import { FilterForm } from './types';

interface FiltersProps {
  formik: FormikProps<FilterForm>;
  showError?: boolean;
}

const Filters: React.FC<FiltersProps> = ({ formik, showError = false }) => {
  const companies = useAppSelector(getCompanyLabels);
  const requestTypes = useAppSelector(getRequestTypeOptionLabels);

  const items: CollapseProps['items'] = [
    {
      id: 'REQUEST TYPE',
      label: 'Request Type',
      children: (
        <MultiSelect<FilterForm>
          formik={formik}
          formikKey="requestTypes"
          options={requestTypes}
        />
      ),
    },
    {
      id: 'EMPLOYEE NUMBER',
      label: 'Employee Number',
      children: <Input<FilterForm> formik={formik} formikKey="empNumber" />,
    },
    {
      id: 'COMPANY',
      label: 'Company',
      children: (
        <MultiSelect<FilterForm>
          formik={formik}
          formikKey="companies"
          options={companies}
        />
      ),
    },
    {
      id: 'CREATED DATE RANGE',
      label: 'Created Date Range',
      children: (
        <DateRange<FilterForm>
          formik={formik}
          fromKey="createdDateFrom"
          toKey="createdDateTo"
        />
      ),
    },
  ];

  return (
    <MFilter<FilterForm> showError={showError} formik={formik} items={items} />
  );
};

export default Filters;
